import { useEffect, useState } from "react";
import { IMG_ABOUT } from "../lib/images";
import { api } from "../lib/api";

export default function About() {
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    api.get("/content/about").then(({ data }) => setBlocks(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="about-page">
      <section className="relative min-h-[420px] flex items-center">
        <div className="absolute inset-0">
          <img src={IMG_ABOUT} alt="A golden wildflower field at sunset" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-midnight-black/60" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 text-center">
          <p className="text-stranger-orange text-xs font-bold tracking-[0.25em] uppercase mb-4">Our Mission</p>
          <h1 className="text-clean-white font-extrabold uppercase tracking-tight text-3xl sm:text-5xl">Why Stranger Sessions Exists</h1>
        </div>
      </section>

      <section className="bg-clean-white py-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 space-y-6 text-lg font-medium text-midnight-black/80 leading-relaxed">
          {blocks.map((b) =>
            b.is_highlight ? (
              <p key={b.id} className="text-stranger-orange font-bold text-xl" data-testid="about-mission-statement">
                {b.body}
              </p>
            ) : (
              <p key={b.id}>{b.body}</p>
            )
          )}
        </div>
      </section>
    </div>
  );
}
